import { getInternalMaterialProductName, SiteMaterialDetail } from 'api';
import { Stack, Typography, TypographyIcon } from 'ui';
import { Business, Inventory } from 'ui/icons';

export const SiteHeader = ({ siteMaterial }: { siteMaterial: SiteMaterialDetail }) => {
  let materialName = `${siteMaterial.material_spec.title} ${siteMaterial.grade.name}`;
  if (siteMaterial.material_product) {
    materialName = getInternalMaterialProductName(siteMaterial.material_product);
  }
  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        {siteMaterial.site.trade_company.name}
      </Typography>
      <TypographyIcon size="small" variant="body2" icon={Inventory}>
        {materialName}
      </TypographyIcon>
      <TypographyIcon size="small" variant="body2" icon={Business}>
        {siteMaterial.site.full_address}
      </TypographyIcon>
    </Stack>
  );
};
